import * as React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../cn';

export interface LoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  /** Skeleton block count for a list/table placeholder. */
  rows?: number;
}

/**
 * EDS governed Loading state — Design Bible §10.
 * Announces politely (aria-live) and respects reduced motion.
 */
export const Loading: React.FC<LoadingProps> = ({ label = 'Loading…', rows, className, ...props }) => {
  if (rows && rows > 0) {
    return (
      <div className={cn('space-y-2.5', className)} aria-busy="true" aria-live="polite" {...props}>
        <span className="sr-only">{label}</span>
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            className="h-11 w-full animate-eds-pulse rounded-eds-md bg-eds-muted motion-reduce:animate-none"
          />
        ))}
      </div>
    );
  }
  return (
    <div
      className={cn('flex items-center justify-center gap-2 py-10 text-eds-muted-fg', className)}
      aria-busy="true"
      aria-live="polite"
      {...props}
    >
      <Loader2 className="h-5 w-5 animate-spin motion-reduce:animate-none" aria-hidden="true" />
      <span className="font-eds-body text-sm">{label}</span>
    </div>
  );
};

export default Loading;
